<template>
	<div class="experience-phone">
		<!-- <div class="card-container">
			<div class="row row-hubs">
				<div class="col-12">
					<div class="experience-header">
						<h2 class="merriweather-reg-20">Bien plus</h2>
						<h2 class="merriweather-reg-26">Qu’une simple nuit</h2>
						<p class="merriweather-light-18 text-center">Le Club Hortense vous ouvre les portes d’un monde où chaque instant devient un <span class="merriweather-light-italic-18">privilège</span></p>
					</div>
				</div>
			</div>
			<div class="row row-hubs pt-5 pb-5">
				<div class="row-grid">
					<div class="col-hub" @click="goToGroup('/reservation-hotel')">
						<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/EXPE%CC%81RIENCES+EXCLUSIVES.jpg" alt="Expériences exclusives">
						</div>
            <p class="raleway-bold-p16 pt-3 w-100 title-text">Expérience exclusive</p>
            <p class="raleway-reg-p15">Accédez à des services négociés pour des moments privilégiés uniques.</p>
					</div>
					<div class="col-hub" @click="goToGroup('/collections/hotel-escapade-gourmande')">
						<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/EXPE%CC%81RIENCES+CULINAIRE.jpg" alt="Expérience culinaire">
						</div>
            <p class="raleway-bold-p16 pt-3 w-100 title-text">Expérience culinaire</p>
            <p class="raleway-reg-p15">Savourez les meilleures saveurs locales dans des lieux sélectionnés avec soin.</p>
					</div>
					<div class="col-hub" @click="goToGroup('/collections/hotel-spa')">
						<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/EXPE%CC%81RIENCES+BIEN-E%CC%82TRE.jpg" alt="Expérience bien-être">
						</div>
            <p class="raleway-bold-p16 pt-3 w-100 title-text">Expérience bien-être</p>
            <p class="raleway-reg-p15">Séjournez dans des hébergements d’exception, choisis pour votre confort.</p>
					</div>
					<div class="col-hub" @click="goToGroup('/reservation-hotel')">
						<div class="card-hub" data-aos="fade-up" data-aos-duration="900">
							<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/EXPERIENCES+AUTHENTIQUES+ET+LOCALES.jpg" alt="Expérience locale">
						</div>
            <p class="raleway-bold-p16 pt-3 w-100 title-text">Expérience locale</p>
            <p class="raleway-reg-p15">Explorez facilement la région grâce à nos guides et carnets d’adresses exclusifs.</p>
					</div>
				</div>
			</div>
		</div> -->
    <div class="experience-card-leave">
      <div class="d-flex flex-column align-items-center justify-content-center w-100" style="gap: 13px;">
        <div class="leave-left py-3">
          <img src="../images/badge-member.png" alt="feuille gauche" class="img-leaf-left">
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center text-center">
          <p class="raleway-bold-h3">Rejoignez le Club Hortense et accédez à un monde de privilèges</p>
          <a class="hortense-btn-primary raleway-bold-p w-100 px-4" target="_blank" @click="showModal = true">Devenir membre</a>
          <p class="raleway-reg-p15 pt-3 cursor-pointer link-item text-underline" @click="goToGroup('https://www.hortense.green/le-club-hortense')">
            En savoir plus sur le Club Hortense
          </p>
        </div>
      </div>
    </div>
    <Modalsignup v-if="showModal" @close="showModal = false"></Modalsignup>
	</div>
  
</template>

<script>
import Modalsignup from './modals/Modalsignup.vue';
	export default {
		name: 'ExperienceHomeNew',
    components: { Modalsignup },
		data() {
			return {
        showModal: false,
      };
		},
		methods: {
			goToGroup(url){
        window.open(url, '_blank');
      }
		},
	};
</script>

<style lang="scss" scoped>
.experience-phone {
  padding-top: 40px;

  .experience-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .row-hubs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
  }

  .row-grid {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    grid-gap: 20px;
    overflow-x: auto;
  }

  .col-hub {
    flex: 0 0 18%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .card-hub {
    position: relative;
    width: 100%;
    cursor: pointer;
  }

  .card-hub img {
    width: 300px;
    height: 400px;
    object-fit: cover;
  }

  .card-hub p {
    align-items: start;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .experience-card-leave {
    background-image: linear-gradient(270.13deg, rgba(255, 255, 255, 0) 12.44%, rgba(255, 255, 255, 0.8) 58.96%),
      url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-club-green-note.jpg');
    width: 100%;
    height: 363px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 10px;

    .link-item {
      text-decoration: underline;
    }
  }
  .text-underline {
    text-decoration: underline;
  }

  .title-text {
    line-height: 100%;
  }
}
</style>
